import React, { useState, useEffect } from "react";
import { UserBasicInfo, UserSettings } from "../components/core/Users";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { ListView } from "../components/secondary/ListView";
import { LIST_VIEW_LIMIT, USER, SUCCESS_STATUS, USERPENDLOCK /* Pending & Locked Button */ } from "../constants";
import {
  getCallBackListAsync,
  resetUsers,
  userDetailsAsync,
  userUpdateAsync,
  setDetailViewData,
  deleteUserListAsync,
  uploadFile,
  getUserRoleAsync,
  setUploadStatus,
  uploadingCheckAsync,
} from "../app/userSlice";
import { List, Search, Sorting, Pagination, Delete, SelectedRow, ListPendLock /* Pending & Locked Button */ } from "../utils";
import { Header } from "../components/secondary/Header";
import { Tab } from "../components";
import { useAdminView } from "../hooks/useAdminView";

const resolveFilterConfig = (openPend, openLock) => {
  if (!openPend && !openLock) return null;

  if (openPend && openLock) {
    return { btnType: "Both", flag: true };
  }

  if (openPend) {
    return { btnType: "Pending", flag: openPend };
  }

  return { btnType: "Locked", flag: openLock };
};

export const Users = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isAdminView = useAdminView();
  const { userId } = useParams();

  const accessError = useSelector((state) => state.app.accessError);
  const userList = useSelector((state) => state.user.users);
  const userData = useSelector((state) => state.user.detailViewData);
  const deleteStatus = useSelector((state) => state.app.deleteStatus);

  const [offSet, setOffSet] = useState(0);
  const [searchKey, setSearchKey] = useState("");
  const [sortType, setSortType] = useState("");
  const [openPend, setOpenPend] = useState(false);
  const [openLock, setOpenLock] = useState(false);
  const [detailsRowData, setDetailsRowData] = useState([]);
  const [activePage, setActivePage] = useState(1);

  /* update user data */
  const updateUserData = (data) => dispatch(userUpdateAsync(data));
  /* Tabs object */
  const tabList = [
    {
      name: "Basic Info",
      content: <UserBasicInfo userData={userData} facilityOptions={""} updateUserData={updateUserData} />,
    },
    {
      name: "Settings",
      content: <UserSettings userData={userData} updateUserData={updateUserData} />,
    },
  ];

  /* Get User Details */

  const getUserList = () => {
    List(USER, "Get", LIST_VIEW_LIMIT, offSet, dispatch, getCallBackListAsync);
  };

  /* Pending & Locked Button */

  const pendingList = () => {
    setOpenPend((prevState) => !prevState);
  };
  const lockedList = () => {
    setOpenLock((prevState) => !prevState);
  };

  useEffect(() => {
    if (!openPend && !openLock) {
      return getUserList();
    }

    const type = openPend && openLock ? "Both" : openPend ? "Pending" : "Locked";
    ListPendLock(USERPENDLOCK, "Get", LIST_VIEW_LIMIT, offSet, dispatch, getCallBackListAsync, type, openPend || openLock);
  }, [dispatch, offSet, openLock, openPend]);

  /* Pending & Locked Button */

  useEffect(() => {
    setSortType("");
    setSearchKey("");
    dispatch(resetUsers());
    getUserList();
  }, [dispatch]);

  const showFixedColumn = !!userList.data && !!userList.data?.users.length;
  const columns = [
    {
      Header: "Customer #",
      accessor: "customerNumber",
      fixedColumn: showFixedColumn,
      fixedWidth: "120px",
    },
    {
      Header: "First name",
      accessor: "firstName",
      fixedColumn: showFixedColumn,
      fixedWidth: "230px",
    },
    {
      Header: "Last name",
      accessor: "lastName",
      fixedColumn: showFixedColumn,
      fixedWidth: "235px",
    },
    {
      Header: "Email",
      accessor: "email",
      restWidth: "250px",
    },
    {
      Header: "Status",
      accessor: "userStatus",
      restWidth: "120px",
    },
    {
      Header: "Facility",
      accessor: "facility",
      restWidth: "200px",
    },
    {
      Header: "Last login",
      accessor: "lastLogin",
      restWidth: "200px",
    },

    {
      Header: "Phone",
      accessor: "phone",
      restWidth: "170px",
    },
    {
      Header: "Role",
      accessor: "role",
      restWidth: "200px",
    },
  ];

  useEffect(() => {
    if (!userId) {
      dispatch(setDetailViewData({}));
      dispatch(getUserRoleAsync());
      return;
    }

    dispatch(userDetailsAsync(userId, history));
  }, [userId, dispatch]);

  const getSelectedRowData = (data) => {
    SelectedRow(data, setDetailsRowData, "users", history, isAdminView);
  };
  // search list
  const getSearchValue = (event) => {
    if (!event || event.keyCode !== 13) return;
    const value = event.target?.value?.trim() ?? "";
    setOffSet(0);
    setActivePage(1);

    if (!value) {
      setSearchKey("");
      setSortType("");
      if (!openPend && !openLock) {
        getUserList();
        return;
      }
    } else {
      setSearchKey(value);
    }

    const filter = resolveFilterConfig(openPend, openLock);

    Search(
      event,
      filter ? USERPENDLOCK : USER,
      "Get",
      LIST_VIEW_LIMIT,
      offSet,
      dispatch,
      getCallBackListAsync,
      sortType,
      filter?.btnType ?? "",
      filter?.flag ?? ""
    );
  };

  // pagination
  const getActivePage = (data) => {
    setOffSet(data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT < LIST_VIEW_LIMIT ? 0 : data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT);

    const filter = resolveFilterConfig(openPend, openLock);

    Pagination(
      data,
      setActivePage,
      filter ? USERPENDLOCK : USER,
      "Get",
      LIST_VIEW_LIMIT,
      dispatch,
      getCallBackListAsync,
      searchKey,
      "",
      sortType,
      filter?.btnType ?? "",
      filter?.flag ?? ""
    );
  };

  // sorting
  const filter = resolveFilterConfig(openPend, openLock);

  const sortingPayLoad = filter
    ? Sorting(USERPENDLOCK, "Get", LIST_VIEW_LIMIT, offSet, getCallBackListAsync, searchKey, sortType, setSortType, filter.btnType, filter.flag)
    : Sorting(USER, "Get", LIST_VIEW_LIMIT, offSet, getCallBackListAsync, searchKey, sortType, setSortType, "", "");

  //delete
  const deleteList = (data) => {
    Delete(data, dispatch, deleteUserListAsync);
  };

  useEffect(() => {
    if (!deleteStatus || deleteStatus.status !== SUCCESS_STATUS) return;
    const filter = resolveFilterConfig(openPend, openLock);
    if (!filter) {
      getUserList();
      return;
    }

    ListPendLock(USERPENDLOCK, "Get", LIST_VIEW_LIMIT, offSet, dispatch, getCallBackListAsync, filter.btnType, filter.flag);
  }, [deleteStatus]);

  return (
    <div>
      {!userId && (
        <ListView
          columns={columns}
          data={userList.data && userList.data?.users}
          metaData={userList.data && userList.data?.metadata}
          sorting={true}
          rowSelect={isAdminView}
          getSelectedRowData={getSelectedRowData}
          detailView={true}
          pageRangeDisplayed={5}
          searchPlaceholder={"First Name, Last Name, Email, Phone number, Customer #, Role, Status"}
          getSearchValue={(e) => getSearchValue(e)}
          detailsRow={!userId}
          activePage={activePage}
          getActivePage={getActivePage}
          listSorting={sortingPayLoad}
          listType={"Users"}
          subHeading={"User Profile"}
          showFixedColumn={showFixedColumn}
          deleteListView={deleteList}
          searchKey={searchKey ? searchKey : ""}
          fileUplodad={uploadFile}
          setUploadStatus={setUploadStatus}
          getUserList={getUserList}
          offset={offSet}
          accessError={accessError}
          sortType={sortType ? sortType : ""}
          pendingList={pendingList} /* Pending & Locked Button */
          lockedList={lockedList} /* Pending & Locked Button */
          openPend={openPend} /* Pending & Locked Button */
          openLock={openLock} /* Pending & Locked Button */
          // getList={getList}
          uploadingCheckAsync={uploadingCheckAsync}
        />
      )}
      {userId && (
        <div>
          <Header heading="Admin" subHeading="User Profile" />
          <Tab tabList={tabList} defaultIndex={0} />
        </div>
      )}
    </div>
  );
};
